var map = {
	"./CleanMedButtonOff.png": "d5f8",
	"./CleanMedButtonOn.png": "ed63",
	"./LongButton.png": "6836",
	"./LongButtonOn.png": "42e0",
	"./Medieval_Dice_v1.png": "e439",
	"./U_Inventory_frame2.png": "99e3",
	"./U_Inventory_frame2_bg.png": "516c",
	"./U_bar_med.png": "a7fb",
	"./U_bar_med2.png": "189c",
	"./U_skill_bar.png": "7e93",
	"./WagdieShopkeeper.png": "9a46",
	"./background.png": "30b3",
	"./burnt.png": "f1ee",
	"./dice.png": "cd3d",
	"./discord.png": "eb10",
	"./flame.png": "ffd3",
	"./fonts/OldLondon.ttf": "0f98",
	"./fonts/Wagdie_Fraktur_36-Regular.ttf": "0dd8",
	"./foolscrown.png": "079b",
	"./gauntlet.png": "565a",
	"./logo.png": "cf05",
	"./mainimage.png": "99b5",
	"./mini_button_fr.png": "924f",
	"./quest_potion.png": "e988",
	"./shopbackground.png": "54bf",
	"./soul.png": "66ea",
	"./the_void.jpg": "62da",
	"./title_bar_1.png": "ff4e",
	"./wagdieverify.png": "bcef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";